const NotFoundPage = () => (
  <div>
    <h1>Not Found</h1>
  </div>
);

export default NotFoundPage;
